export default {
  MARKET_REGIONS: `companies/:company_id/market-regions`
}